import React from 'react';

import ContactUsLink from '@src/components/ContactUsLink';

import styles from './error.scss';

import bootstrap from '@src/css/bootstrap.scss';

/**
 * Error403 - 403 error page
 */

const Error403 = () => {
    return (
        <div id="home" className={`col-12 ${styles.error_page}`}>
            <div className={bootstrap.container}>
                <div className={bootstrap.row}>
                    <div className={`${bootstrap.col} ${bootstrap['text-center']}`}>
                        <div className="error-container">
                            <img src="/img/Computer-Lock-Icon.png" alt="Computer screen with a Lock Pad on the screen" />
                            <h1>We&#39;re Sorry</h1>
                            <h2>You are currently not authorized to view this content.</h2>
                            <p>Please, contact your manager or supervisor for more information.</p>
                            <p>For more support please <ContactUsLink>contact us</ContactUsLink></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error403;
